import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class Constant {
    get api() {
        return environment.api;
    }

    get apiGoogle() {
        return environment.apiGoogle;
    }

    get conektaKey() {
        return environment.conektaKey;
    }

    get firebaseConfig() {
        return environment.firebaseConfig;
    }

    get vapidKeyFirebase() {
        return environment.vapidKeyFirebase;
    }

    get rappiHost() {
        return environment.rappi_host;
    }

    get rappiClientId() {
        return environment.rappi_client_id;
    }

    get rappiClientSecret() {
        return environment.rappi_client_secret;
    }

    get whatsapp() {
        return environment.whatsapp;
    }

    get landing() {
        return environment.landing;
    }

    get conektaScript() {
        return environment.conektaScript;
    }

    get rappiScript() {
        return environment.rappi_script;
    }

    get ws() {
        return environment.ws;
    }

    get apiKeyWeetrust() {
        return environment.api_key_weetrust;
    }

    get script_weetrust() {
        return environment.script_weetrust;
    }

    get stripeKey() {
        return environment.stripe_key;
    }
}
